import React from 'react';
import { useSelector } from 'react-redux';
import { getPlayerDuelState } from '../store/selectors/playerDuelSelector';
import FieldVisionPlayerDuel from '../FieldVisionPlayerDuel';

const FieldVisionPlayerDuelDataContainer = (props) => {
    const playerDuelState = useSelector(getPlayerDuelState);

    return (
        <FieldVisionPlayerDuel { ...playerDuelState } { ...props } />
    );
};

export default FieldVisionPlayerDuelDataContainer;
